/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useToasts } from "react-toast-notifications";
import { Link } from "react-router-dom";
import { globalLoadingOff, globalLoadingOn } from "../slices/globalLoading/globalLoadingSlice";
import { selectCurrentUserApiToken, selectCurrentUserId, selectCurrentUserNotificationFois } from "../slices/currentUser/currentUserSlice";
import getResourcesTitlesAndTypes from "../functions/getResourceTitlesAndTypesAPI";
import updateUserNotifications from "../slices/notifications/notificationsFunctionsAPI";
import { ReactComponent as BellEmoji } from '../assets/bellemoji.svg';

const updateNotificationResources = async (addToast, followedFOIsState, setFollowedFOIsState,
    resourceId, editor = false, apiToken) => {
    /* 1. Send to server. 2. Toast. 3. Change the bell. */
    //THIS IS INCOMPLETE CODE
    let foi = parseInt(resourceId);
    let removeFromNotifcations = followedFOIsState.includes(foi);

    //This set State is to get instant webpage feedback of the bell displaying while it submits to the server
    setFollowedFOIsState((prevState) => {
        if (removeFromNotifcations) {
            prevState.splice(prevState.indexOf(foi), 1);    //removes foi from list
        } else {
            prevState.push(foi);        //otherwise add it
        }
        return [...prevState];
    });

    let response = await updateUserNotifications(foi, apiToken, removeFromNotifcations, editor);
    if (response?.success) {
        if (removeFromNotifcations) {
            addToast('You will no longer be notified for this Resource.', { appearance: 'success' });
        } else {
            addToast('You will be notified for this Resource.', { appearance: 'success' });
        }
    } else if (response?.errormessage) {
        addToast(response.errormessage, { appearance: 'error' });
    } else {
        addToast('Problem updating your notifications.', { appearance: 'error' });
    }
}

const NotificationBell = ({ resourceId, editor, absolutePosition, topOffset, rightOffset, fontSize }) => {
    const apiToken = useSelector(selectCurrentUserApiToken);
    const followedFois = useSelector(selectCurrentUserNotificationFois);
    const userId = useSelector(selectCurrentUserId);
    const isLoggedIn = (!!userId && userId !== "1");
    const { addToast } = useToasts();

    const [followedFOIsState, setFollowedFOIsState] = useState([]);

    useEffect(() => {
        if (followedFois) {
            setFollowedFOIsState(JSON.parse(JSON.stringify(followedFois)));
        }
    }, [followedFois]);

    useEffect(() => { }, [followedFOIsState]);

    fontSize = fontSize || "18px";
    let style = { fontSize: fontSize, cursor: "pointer" };
    if (absolutePosition) {
        style.position = "absolute";
        style.zIndex = "1000";
        style.top = topOffset || "4px";
        style.right = rightOffset || "30px";
    }
    let notified = (resourceId && followedFOIsState?.includes(parseInt(resourceId)));

    return <>
        {isLoggedIn &&
            <div style={style}
                title={notified ? "You are receiving notifications for this resource" : "Add to Notifications"}
                onClick={() => {
                    updateNotificationResources(addToast, followedFOIsState, setFollowedFOIsState,
                        resourceId, editor, apiToken);
                }}>
                {notified ?
                    <span className="notificationBell notificationBellSelected"><BellEmoji className="inline-emoji" /></span>
                    :
                    <span className="notificationBell notificationBellNotSelected"><BellEmoji className="inline-emoji" /></span>}
            </div>
        }
    </>
}

//MAKE ALPHABETICAL ORDER?
const FhirResourcesLinks = ({ followedFois, notificationResourcesDictState }) => {
    return <div style={{ "textAlign": "left" }}>
        {followedFois?.map((foi, index) => {
            let relativeUrl = "/" + foi;
            let title = foi;
            let status;
            let resourceEntry = notificationResourcesDictState[foi];
            if (resourceEntry) {
                relativeUrl = resourceEntry.relativeUrl;
                title = resourceEntry.title;
                status = resourceEntry.status;
            }
            return <div key={index} className="resourceListEntry" style={{ display: "flex", paddingBottom: "4px", verticalAlign: "top" }}>
                <NotificationBell resourceId={foi} fontSize={"16px"} />
                &nbsp;
                <Link to={relativeUrl}>
                    <span style={{ fontSize: "24px" }}>{title}</span>
                </Link><span>{status !== "active" && <>&nbsp;&nbsp;({status})</>}</span>
            </div>
        })}
    </div>
};

// eslint-disable-next-line no-empty-pattern
const ResourceNotificationsSection = ({ }) => {
    const dispatch = useDispatch();
    const apiToken = useSelector(selectCurrentUserApiToken);
    const followedFois = useSelector(selectCurrentUserNotificationFois);

    const [loadedNotificationsState, setLoadedNotificationsState] = useState([]);
    //const [globalLoadingState, setGlobalLoadingState] = useState(true);
    const [notificationResourcesDictState, setNotificationResourcesDictState] = useState({});

    const loadNotifications = async () => {
        if (apiToken && followedFois && notificationResourcesDictState) { // && globalLoadingState
            let numberOfNotificationResources = followedFois.length;
            if (numberOfNotificationResources > 0 &&
                Object.keys(notificationResourcesDictState).length !== numberOfNotificationResources &&
                loadedNotificationsState.toString() !== followedFois.toString()) {
                //LOADING
                setLoadedNotificationsState([...followedFois]);
                //DO SERVER CALL
                //setGlobalLoadingState(true);
                //dispatch(globalLoadingOn());
                let response = await getResourcesTitlesAndTypes(followedFois, apiToken);
                if (response.success) {
                    setNotificationResourcesDictState(response.resources);
                }
                //setGlobalLoadingState(false);
                //dispatch(globalLoadingOff());
            }
        }
    }

    useEffect(() => {
        loadNotifications();
    }, [apiToken]);

    return <>
        {/*globalLoadingState &&
            <Dimmer className={"loadingDimmer"} active inverted>
                <Loader inverted>Loading</Loader>
            </Dimmer>
        */}
        {(!followedFois && followedFois.length === 0) ?
            <h2>You haven't selected any resources to be notified for.</h2>
            :
            <FhirResourcesLinks followedFois={followedFois}
                notificationResourcesDictState={notificationResourcesDictState} />
        }
    </>
}

export { NotificationBell, ResourceNotificationsSection };